import React from 'react'
import Navbar from './Navbar'

const Header = () => {
  return (
    <div className='fixed z-40 w-full'>
        <Navbar />
    </div>
  )
}

export default Header